<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <div class="pa-4">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" :hide-details="true" />
        </div>

        <div class="mb-4">
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.background"
                    @change="event => (fields.styleSection.background = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.background" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.textColor"
                    @change="event => (fields.styleSection.textColor = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.textColor" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.topPadding"
                  label="Top Padding"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.bottomPadding"
                  label="Bottom Padding"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.containerPage.enableStyle"
                  label="Enable Style Container"
                  :hide-details="true"
                />
                <div v-if="fields.containerPage.enableStyle">
                  <v-row>
                    <v-col cols="12" md="6">
                      <label>Background Color</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          :value="fields.containerPage.background"
                          @change="event => (fields.containerPage.background = event.target.value)"
                        />
                        <v-text-field v-model="fields.containerPage.background" :hide-details="true" class="mt-0" />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <div class="label-input">Card Title</div>
          <div class="group-item">
            <v-checkbox
              v-model="fields['show-card-title']"
              label="Show card title"
              :hide-details="true"
              class="mb-2 mt-0"
            />
            <ckeditor :editor="editor" v-model="fields['card-title']" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Grid Items</label>
            <v-btn small color="primary" @click="handleAddItem">Add Item</v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, index) in fields.items" :key="`grid-item-${index}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Item {{ index + 1 }}</span>
                  <v-btn small icon @click.stop="handleRemoveItem(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <UploadImage
                  @callback="obj => handleUploadImage(obj, index)"
                  :image="{ imageSrc: item.image }"
                  :height="`220`"
                  :typeUpload="'image'"
                  @callbackDelete="() => handleRemoveUpload(index)"
                />
                <div class="mb-3 mt-3">
                  <label>Link</label>
                  <v-text-field v-model="item.link" :hide-details="true" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '../common/form/upload-file/upload-image.vue';
import { updateHtmlFromData } from '../common/html/update';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

const defaultGridItem = () => ({
  image: 'https://www.hsialife.com/cdn/shop/files/hsia-minimizer-bra-on-model.jpg?v=1778124445&width=790',
  link: '#',
});

const defaultFields = () => ({
  title: 'Card Hsia Grid Section',
  'card-title':
    '<h2>Minimizer Bra</h2><p>Discover our range of minimizer bras, designed to provide the perfect fit for every body.</p>',
  'show-card-title': true,
  styleSection: {
    topPadding: true,
    bottomPadding: true,
    background: '#FFFFFF',
    textColor: '#000000',
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  items: [defaultGridItem(), defaultGridItem(), defaultGridItem(), defaultGridItem()],
});

export default {
  name: 'CardHsiaGrid',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: defaultFields(),
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
    };
  },
  mounted() {
    const fallback = defaultFields();
    const extracted = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...fallback,
      ...extracted,
      styleSection: {
        ...fallback.styleSection,
        ...(extracted.styleSection || {}),
      },
      containerPage: {
        ...fallback.containerPage,
        ...(extracted.containerPage || {}),
      },
      items: Array.isArray(extracted.items) && extracted.items.length ? extracted.items : fallback.items,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        items: (this.fields.items || []).filter(Boolean).map(item => ({
          image: item.image || '',
          link: item.link || '#',
        })),
      };

      if (!payload.items.length) {
        payload.items = [defaultGridItem()];
      }

      const updateHtml = updateHtmlFromData.sectionCardHsiaGrid(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: payload.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.items.push(defaultGridItem());
    },
    handleRemoveItem(index) {
      if (this.fields.items.length <= 1) return;
      this.fields.items.splice(index, 1);
    },
    handleUploadImage(obj, index) {
      this.fields.items[index].image = obj.imageSrc || '';
    },
    handleRemoveUpload(index) {
      this.fields.items[index].image = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 5px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  border: 1px solid #0000000f;
  border-radius: 8px;
  padding: 16px 12px;
  margin-bottom: 10px;
}
</style>
